import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../webserviceUrls"
import { CompilationModel, CompilationsFindResponse } from ".."

export function findCompilationsEmbedded(query?: string, pageIndex?: number, pageSize?: number) {
    const url = `${WebserviceUrl.CompilationsArticleCompilationsEmbedded}/CompilationsFind`
    const body = { query, pageIndex, pageSize }

    return ajaxAuth<CompilationsFindResponse>({ url, body }).then(
        (response) =>
            response && {
                ...response,
                compilations: response.compilations.map((compilation): CompilationModel => {
                    return {
                        ...compilation,
                        isOwn: true,
                        isPublic: true,
                    }
                }),
            }
    )
}
